<div class="video-widget" [ngClass]="getClasses()" [class.is-playing]="isPlaying">
  <div class="video-element" #videoContainer>
    <div class="thumbnail" (click)="playVideo()">
      <app-webp-image [src]="getThumbnailUrl()" [alt]="widget.data.description || 'Video thumbnail'"></app-webp-image>
    </div>
    <div class="player-wrapper" *ngIf="getVideoId()">
      <youtube-player
        #player
        [videoId]="getVideoId()"
        (stateChange)="onPlayerStateChange($event)"
      ></youtube-player>
    </div>
  </div>
  <div class="video-description" [innerHtml]="widget.data.description">
  </div>
</div>
